import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';

const columns = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'mainDrawNum', headerName: '主件圖號', minWidth: 150, flex: 1 },
  { field: 'buildDate', headerName: '建檔日期', width: 120, editable: true },
  { field: 'preDays', headerName: '提前天數', type: 'number', width: 110, editable: true },
];

export default function BomMainDataGrid({ data, newData, onMainDrawNumSelect, onHeaderChange }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(newData?.mainBoms || data?.mainBoms || []);
  }, [data, newData]);

  const processRowUpdate = (newRow) => {
    const normalized = { ...newRow, preDays: Number(newRow.preDays) };
    setRows((current) => current.map((row) => row.id === normalized.id ? normalized : row));
    onHeaderChange?.(normalized);
    return normalized;
  };

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        pageSizeOptions={[10, 20]}
        rowHeight={38}
        columnHeaderHeight={32}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={(error) => alert(error?.message || '主件資料格式錯誤')}
        onRowClick={(params) => onMainDrawNumSelect?.(params.row.mainDrawNum, params.row)}
        disableRowSelectionOnClick
      />
    </Box>
  );
}
